import type { AnchorHTMLAttributes } from "react";

// Internal-navigation primitive — a plain <a> that performs a full browser
// navigation instead of next/link's client-side (SPA) routing.
//
// Every link click becomes a real new pageview, which is what keeps AdSense
// healthy: the loader re-runs on a fresh document, Auto Ads re-evaluate the
// page from scratch, and every manual ad slot requests a new fill — all tied
// to a genuine user action, so impressions stay policy-compliant. It also
// removes the SPA-only Auto Ads re-trigger that used to flicker the side rails.
//
// next/link-only props (prefetch / replace / scroll) were stripped from the
// call sites during migration — a full reload has no client-side router for
// them to act on.
interface LinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
}

export default function Link(props: LinkProps) {
  return <a {...props} />;
}
